import { useEffect } from "react";
import { HashRouter, Route } from "react-router-dom";
import { UserLogin } from "./UserLogin.jsx";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import indexRoutes from "../../routes/routeIndex.jsx";
import HashPageTracker from "../Utilities/HashPageTracker.jsx";
import "../../assets/css/custom.css";

function AppLogin() {
  useEffect(() => {
    window.addEventListener("beforeunload", function () {
      localStorage.setItem("filter", null);
      localStorage.setItem("strFilter", null);
    });
  }, []);
  // console.log(accounts);

  return (
    <div>
      <AuthenticatedTemplate>
        <HashRouter>
          <HashPageTracker />
          {indexRoutes.map((prop, key) => {
            return (
              <Route to={prop.path} component={prop.component} key={key} />
            );
          })}
        </HashRouter>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <UserLogin />
        <div className="userLoginMsg">
          Not an authenticated user, redirecting to login page..
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
}

export default AppLogin;
